import caiLogoPng from '../../assets/CAI Full Color.png';
import caiLogoBlack from '../../assets/CAI Black.png';
  
const Footer = () => {
    return (
        <div
            className="footer flex justify-center items-center relative bg-color-cai-lightGray h-[100px] w-full max-w-[800px]"
            style={{
                // position: 'fixed',
                bottom: 0,
                left: 0,
                width: '100%',
                height: '100px',
            }}
        >
            <div
                className="absolute inset-0"
                style={{
                    backgroundImage: `url(${caiLogoBlack})`,
                    backgroundPosition: 'center center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    opacity: 0.3, // Adjust opacity here
                }}
            />
            <img
                src={caiLogoPng}
                alt="CAI Logo"
                className="absolute bottom-2 right-10 w-48 h-auto"
            />
        </div>
    );
};
  
export default Footer;


